
































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  getAuth,
  Auth,
  UserCredential,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";

@Component
export default class LoginScreen extends Vue {
  @Prop() private msg!: string;

  email = "";
  password = "";
  message = "";
  auth: Auth | null = null;

  mounted(): void {
    this.auth = getAuth();
  }

  showMessage(txt: string) {
    this.message = txt;

    // The message will automatically disappear after 5 seconds
    setTimeout(() => {
      this.message = "";
    }, 5000);
  }

  pushToHome(): void {
    this.$router.push({ name: "home" });
  }

  pushToSignup(): void {
    this.$router.push({ name: "signup" });
  }

  emailLogin(): void {
    signInWithEmailAndPassword(this.auth!, this.email, this.password)
      .then(async (cr: UserCredential) => {
        if (cr.user.emailVerified) {
          this.pushToHome();
        } else {
          this.showMessage("You must first verify your email");
          await signOut(this.auth!);
        }
      })
      .catch((err: any) => {
        this.showMessage(`Unable to login ${err}`);
      });
  }

  resetPass(): void {
    sendPasswordResetEmail(this.auth!, this.email)
      .then(() => {
        this.showMessage(
          `A Password Reset Link Has Been Sent To ${this.email}`
        );
      })
      .catch((err: any) => {
        this.showMessage("Unable to reset password ${err}");
      });
  }
}
